import React from "react";

import {
  secToDateTimeString,
  secToTimeString,
  ZOOM_PRESETS,
} from "../../utils/playbackUtils";

export default function PlaybackTimeline({
  selectedDate,

  zoomLevel,
  onZoomChange,
  onJumpWindow,

  windowStartSec,
  windowEndSec,

  axisLabels,
  timelineRef,
  onTimelineClick,

  timelineRuns,

  playheadSec,
  playheadPercent,
}) {
  return (
    <div className="flex min-h-0 flex-col rounded-2xl bg-white p-3 shadow-md dark:bg-[#1F2A3B] lg:flex-[0.62]">
      <div className="mb-3 flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <h4 className="text-base font-bold">타임라인</h4>

        <div className="flex flex-wrap items-center gap-2">
          {ZOOM_PRESETS.map((preset) => (
            <button
              key={preset.key}
              onClick={() => onZoomChange(preset.key)}
              className={`rounded-xl border px-3 py-1.5 text-sm ${
                zoomLevel === preset.key
                  ? "border-blue-600 bg-blue-600 text-white"
                  : "border-gray-300 bg-white dark:border-gray-600 dark:bg-[#111827]"
              }`}
            >
              {preset.label}
            </button>
          ))}

          <button
            onClick={() => onJumpWindow(-1)}
            className="rounded-xl bg-gray-200 px-3 py-1.5 text-sm dark:bg-gray-700"
          >
            ← 이동
          </button>

          <button
            onClick={() => onJumpWindow(1)}
            className="rounded-xl bg-gray-200 px-3 py-1.5 text-sm dark:bg-gray-700"
          >
            이동 →
          </button>
        </div>
      </div>

      <div className="mb-2 break-words text-xs text-gray-500 dark:text-gray-400">
        현재 보기 범위: {secToDateTimeString(selectedDate, windowStartSec)} ~{" "}
        {secToDateTimeString(selectedDate, windowEndSec)}
      </div>

      <div className="min-h-0 flex-1">
        <div
          className={`mb-2 grid text-[11px] text-gray-500 dark:text-gray-400 ${
            axisLabels.length <= 4 ? "grid-cols-4" : "grid-cols-7"
          }`}
        >
          {axisLabels.map((label, idx) => (
            <span
              key={`${label}-${idx}`}
              className={`${
                idx === 0
                  ? "text-left"
                  : idx === axisLabels.length - 1
                  ? "text-right"
                  : "text-center"
              }`}
            >
              {label}
            </span>
          ))}
        </div>

        {/* CCTV/NVR 방식 타임라인: 한 줄짜리 트랙 위에 "연속 녹화 구간"을 파란 띠로 표시.
            끊긴 구간은 비워둠. 트랙 아무 곳이나 누르면 그 시각부터 재생(부모 onTimelineClick). */}
        <div
          ref={timelineRef}
          onClick={onTimelineClick}
          className="relative h-10 w-full cursor-pointer overflow-hidden rounded-xl border border-gray-200 bg-gray-100 dark:border-gray-700 dark:bg-[#0F172A] sm:h-8"
        >
          {timelineRuns.length === 0 ? (
            <div className="absolute inset-0 flex items-center justify-center px-3 text-center text-xs text-gray-400">
              녹화 구간 데이터 없음
            </div>
          ) : (
            <>
              {timelineRuns.map((run) => (
                <div
                  key={run.id}
                  title={`녹화 ${secToTimeString(run.startSec)} ~ ${secToTimeString(
                    run.endSec
                  )}`}
                  className="pointer-events-none absolute top-1/2 h-7 -translate-y-1/2 rounded-md bg-blue-500/90 sm:h-[22px]"
                  style={{
                    left: `${run.leftPercent}%`,
                    width: `${run.widthPercent}%`,
                  }}
                />
              ))}

              {playheadPercent !== null &&
                playheadPercent >= 0 &&
                playheadPercent <= 100 && (
                  <div
                    className="pointer-events-none absolute bottom-0 top-0 z-20 w-[3px] bg-red-500 sm:w-[2px]"
                    style={{ left: `${playheadPercent}%` }}
                  />
                )}
            </>
          )}
        </div>

        <div className="mt-2 flex items-center justify-between text-[11px] text-gray-500 dark:text-gray-400">
          <span>
            파란 띠 = 녹화된 구간 · 타임라인을 누르면 그 시각부터 재생됩니다.
          </span>
          {playheadSec != null && (
            <span className="font-semibold text-gray-700 dark:text-gray-200">
              {secToTimeString(playheadSec)}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
